import { state } from '../state'
import { updateEntities } from './entity-service'
import { ensureCurrentLinkedPlayerBuilds } from './linked-player-builds-service'
import { getRunEndRoute } from './quest-bridge'

export const environmentHostName = window.location.hostname.includes('-') ? window.location.hostname : ''

let initialized = false

export function reset() {
  initialized = false
}

export async function handleNavigation(path: string) {
  const { user, organizationId } = state
  if (!user || !organizationId || initialized) {
    return
  }
  const updateEntitiesPromise = updateEntities(true)
  await ensureCurrentLinkedPlayerBuilds()
  if (Object.keys(state.courses).length === 0) {
    await updateEntitiesPromise
  }
  initialized = true
  const runEndRoute = await getRunEndRoute(path)
  if (runEndRoute) {
    return runEndRoute
  }
}
